import { createSelector } from "reselect";

import getBrowserVersionFloat from "selectors/device/getBrowserVersionFloat";
import getIsChrome from "selectors/device/getIsChrome";
import getIsEdge from "selectors/device/getIsEdge";
import getIsFirefox from "selectors/device/getIsFirefox";
import getIsIE from "selectors/device/getIsIE";
import getIsiOS from "selectors/device/getIsMobileSafari";
import getIsOldAndroid from "selectors/device/getIsOldAndroid";
import getIsWindows7 from "selectors/device/getIsWindows7";

export default createSelector(
  [
    getBrowserVersionFloat,
    getIsChrome,
    getIsEdge,
    getIsFirefox,
    getIsIE,
    getIsiOS,
    getIsOldAndroid,
    getIsWindows7,
  ],
  (
    browserVersionFloat,
    isChrome,
    isEdge,
    isFirefox,
    isIE,
    isiOS,
    isOldAndroid,
    isWindows7,
  ) => {
    if (isiOS) {
      return false;
    }
    if (
      browserVersionFloat &&
      isChrome &&
      browserVersionFloat >= 23 &&
      !isOldAndroid
    ) {
      // Chrome 23+
      return true;
    }
    if (isEdge) {
      return true;
    }
    if (
      browserVersionFloat &&
      isIE &&
      browserVersionFloat >= 11 &&
      !isWindows7
    ) {
      // IE11+
      return true;
    }
    if (browserVersionFloat && isFirefox && browserVersionFloat >= 42) {
      return true;
    }

    return false;
  },
);
